import React, { useState, useEffect } from 'react';
import { FormComponent } from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';
import { searchService, loggedInUserService, currentDocumentService } from '../services';
import Moment from 'react-moment';
import TimelineEvent from './CrmTimelineEvent';

import './CrmTimelineStyle.less';

const collateCrmEvents = (events : Array<any>) => {
  let out = [];
  let lastWasStage = false;
  events.reverse().forEach( (event) => { 
    let isThisStage = event.historyType === 'Stage Change';

    if ( isThisStage && lastWasStage )
    {
      let lastEvent = out[ out.length - 1 ];
      let lastEventDireciton = ( lastEvent.extraData.new - lastEvent.extraData.old ) < 0;
      let eventDireciton = ( event.extraData.new - event.extraData.old ) < 0;

      if ( eventDireciton == lastEventDireciton )
      {
        lastEvent.extraData.new = event.extraData.new;
        lastEvent.extraData.collated = true;
        lastEvent.extraData.timeEnd = event.historyTime;
        lastEvent.historyDesc = "Stage Change: " + lastEvent.extraData.old + " > " + lastEvent.extraData.new;
        out[ out.length - 1 ] = lastEvent;
      }
      else out.push( event );
    }
    else out.push( event );

    lastWasStage = isThisStage;
  } )
  return out.reverse();
}

const CrmTimelineFilterTypesCheckbox = ( {fieldName, typeFilter, setTypeFilter, refreshing} ) => {
  return <li className={refreshing ? " disabled" : ""}>
    <a onClick={ () => typeFilter.indexOf(fieldName) === -1 ? setTypeFilter( typeFilter.concat( [fieldName] ) ) : setTypeFilter( typeFilter.filter( x => x !== fieldName ) ) }>
      <input type="checkbox" checked={ typeFilter.indexOf(fieldName) !== -1 } /> {fieldName}
    </a>
  </li>;
};

const CrmTimelineHeaderControls = ({refresh, page, maxPage, setPage, setRefresh, setPageSafe, typeFilter, setTypeFilter, textFilter, setTextFilter}) => {

  let pageInput = maxPage > 1 ? [
      (<div className={"btn btn-primary btn-xs panel-nav-btn-group " + (refresh ? " disabled" : "")} onClick={() => setPageSafe( page - 1 )}><span>&laquo;</span></div>),
      (<div className="btn btn-xs"><span>{page + 1} / {maxPage}</span></div>),
      (<div className={"btn btn-primary btn-xs " + (refresh ? " disabled" : "")} onClick={() => setPageSafe( page + 1 )}><span>&raquo;</span></div>)
  ] : []

  let refreshButton = (<div className="btn btn-primary btn-xs panel-nav-btn-group" onClick={()=>{setRefresh( true ); setPage( 0 );}}>Refresh</div> );

  let onSearchFilterChange = ( event ) => {
      setTextFilter( event.target.value );
  };

  let submitFilterOnEnter = ( event ) => {
      if (event.key === 'Enter') {
          onSearchFilterChange( event )
      }
  };

  let filterSearchBox = (
    <li className={refresh ? " disabled" : ""} onClick={(e)=> e.stopPropagation()}> 
        <a>
            <input type="text" class="form-control" placeholder="Search..." onBlur={onSearchFilterChange} onKeyPress={submitFilterOnEnter}/>
        </a>
    </li>);
    
  let filters = [
    <div className="btn btn-primary btn-xs dropdown-toggle" data-toggle='dropdown'>Filters</div>,
    <ul className="dropdown-menu" onClick={(e)=> e.stopPropagation()}>
      {filterSearchBox}
      <CrmTimelineFilterTypesCheckbox fieldName={"Action"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Budget"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Confidence Change"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Discovery"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Email Read"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Email Click Link"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Order"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
      <CrmTimelineFilterTypesCheckbox fieldName={"Stage Change"} typeFilter={typeFilter} setTypeFilter={setTypeFilter} refreshing={refresh} />
    </ul>
  ]

  let group1 = <div className="btn-group btn-group-xs panel-nav-btn-group">{refreshButton}{filters}</div>;

  let pageSelector = maxPage > 1 ? 
    [ group1, pageInput ] : 
    group1;

  return pageSelector;
};

const CrmTimelineComponent = ({
  document,
  fieldValue,
  template,
  fieldName,
  formParameters,
  key,
  responsiveLayouts,
  message,
  componentDefinition
}) => {
  const [refresh, setRefresh] = useState(true);
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(1);
  const [textFilter, setTextFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState( 
    componentDefinition.defaultTypeFilter !== undefined ? 
    componentDefinition.defaultTypeFilter : 
    [
      "Stage Change",
      "Confidence Change",
      "Budget",
      "Email Read",
      "Email Click Link",
      "Action",
      "Discovery",
      "Order"
    ] 
  );
  let pageLength = 25;

  let generateQuery = () => {
    let docIdToLinkTo = [ document.documentId ];
    
    if ( componentDefinition?.noDefaultFilter )
      docIdToLinkTo = [ ];

    let innerFilter:any = [
      { "term": { "appTags": "crm" } },
      { "term": { "appTags": "history" } },
      { "term": { "systemHeader.systemType": "document" } }
    ];
    let addFilter = x => 
    {
      let y = { 
        "term": { "historyDocs.documentId": x } 
      }
      innerFilter.push( y );
    }

    docIdToLinkTo.forEach( x => addFilter( x ) );

    let must = []

    if ( typeFilter.length > 0 )
    { 
      let should = typeFilter.map( historyType => {
        return { 'term': { "historyType": historyType } }
      } );
      must.push( {
        "bool": {
          "should": should,
          "minimum_should_match": 1
        }
      } );
    }

    if ( textFilter.length > 0 )
    {
      let wildcardedTextFilter = "*" + textFilter + "*"
      must.push( {
        "bool": {
          "should": [
            { 'wildcard': { "historyDesc": {"value": wildcardedTextFilter, "case_insensitive": true } } },
            { 'wildcard': { "historyDocs.name": {"value": wildcardedTextFilter, "case_insensitive": true } } },
            { 'wildcard': { "notes": {"value": wildcardedTextFilter, "case_insensitive": true } } },
          ],
          "minimum_should_match": 1
        }
      } );
    }

    return {
      "query": {
        "bool": {
          "filter": innerFilter,
          "must": must,
        }
      },
      "sort": [ {
          "historyTime": "desc"
      } ]
    }
  };

  // On View Refresh
  useEffect(() => {
    if ( refresh !== false )
    {
      let qury = generateQuery()
      setEvents( [] );
      searchService.search({
        filter: qury,
        page: page,
        size: pageLength
      }).
        then(result => {
          setEvents(result.data.hits.hits.map(x => x._source));
          setRefresh( false );
          let newMxPage = Math.ceil( result.data.hits.total / pageLength );
          setMaxPage( newMxPage <= 0 ? 1 : newMxPage );
        }).catch(e => console.error(e));
       
      return;
    }
  }, [refresh]);

  useEffect( () => {
    setRefresh( true );
    setPage( 0 );
  }, [typeFilter, textFilter])
  
  let bodyContent = (<div></div>); 
  if ( refresh === false )
    bodyContent = (events.length ? events.map((e, i, a) => <TimelineEvent event={e} last={i == a.length - 1} currentDocId={document.documentId}/>) : (<div />))
  
  let setPageSafe = ( newPage ) => {
    if ( newPage >= 0 && newPage < maxPage )
    {
      setPage( newPage );
      setRefresh( true );
    }
  }

  useEffect( ()=>{
    if ( page >= maxPage )
    {
      setPage( maxPage - 1 );
      setRefresh( true );
    }
  }, [page, maxPage] )

  let pageSelector = <CrmTimelineHeaderControls refresh={refresh} page={page} maxPage={maxPage} setPage={setPage} 
                      setRefresh={setRefresh} setPageSafe={setPageSafe} typeFilter={typeFilter} setTypeFilter={setTypeFilter}
                      textFilter={textFilter} setTextFilter={setTextFilter} />;

  return (
    <div>
      <div className="panel panel-primary">
        <div className="panel-heading">
          <div className="crm-panel-icon-background">
            <i className="fa fa-history crm-panel-icon"/></div>
            History
            {pageSelector}
        </div>
        <div className="panel-body timeline-body">
          {
            events.length === 0 ? 
              (
                <div className="alert alert-info">
                  <i class="fas fa-exclamation-circle"></i> No History
                </div>
              ) : 
              <div/>
          }
          {bodyContent}
        </div>
      </div>
    </div>
  ); 
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('crm-timeline', CrmTimelineComponent);

export default CrmTimelineComponent;
